export const OPENDAPMETA = {
    name: 'OpenDAP downloader',
    message: 'Download ESGF data via OpenDAP.',
    urllist_filename: 'urllist.txt',
    urllist: {
        class: 'File',
        path: './urllist.txt',
    },
};
export const ROOKMETA = {
    name: 'ROOK WPS downloader',
    message: 'Download ESGF data via ROOK WPS.',
    runId: 'placeholder',
};
export const NODATE = { start_time: '', stop_time: '' };
export const DEFAULTDATE = {
    start_time: '2000-01-01',
    stop_time: '2020-12-31',
};
export const NOCOORDINATES = {
    minlat: '9999',
    maxlat: '9999',
    minlon: '9999',
    maxlon: '9999',
};
export const DEFAULTCOORDINATES = {
    minlat: '-90.0',
    maxlat: '90.0',
    minlon: '-180.0',
    maxlon: '180.0',
};
export const COMPLETE = 100;
